'use client'

import { useGetMyInfosQuery, useGetPatientFilesQuery } from '@/core/graphql/hooks'

import type { DocumentFile } from './types'

export function useDocumentsPage() {
  const { data: patientData, loading: patientLoading } = useGetPatientFilesQuery()
  const { data: myInfosData, loading: myInfosLoading } = useGetMyInfosQuery()

  const patientInfos = patientData?.myInfos
  const patientId = myInfosData?.myInfos?._id || ''

  const consultationFiles: DocumentFile[] = (patientInfos?.consultations || [])
    .flatMap((consultation) => consultation.files)
    .map((file) => ({
      filename: file.filename,
      key: file.key,
      url: file.url || '',
    }))

  const patientFiles: DocumentFile[] = (patientInfos?.files || []).map((file) => ({
    filename: file.filename,
    key: file.key,
    url: file.url || '',
  }))

  return {
    loading: patientLoading || myInfosLoading,
    patientId,
    patientFiles,
    consultationFiles,
  }
}
